import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { withStyles } from '@material-ui/core'

import { BigCalendarHeadBase } from './BigCalendarHead'

import { mergedSourcesSelector } from 'reduxModules/selectors/SourceSelectors'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  sources: mergedSourcesSelector
})

const enhance = compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true } )
)

export const BigCalendarHead = enhance(BigCalendarHeadBase)


// WEBPACK FOOTER //
// ./src/components/BigCalendar/components/BigCalendarHead/index.js